import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CatalogsVehicleState } from './catalog-vehicle.models';

export const selectCatalogsVehicleState = createFeatureSelector<CatalogsVehicleState>('catalogsVehicle');

export const selectCatalogsVehicleByUserGuid = (userGuid: string) =>
  createSelector(selectCatalogsVehicleState, (state) => state.catalogs[userGuid] || null);

export const selectCatalogsVehicleLoading = createSelector(selectCatalogsVehicleState, (state) => state.loading);

export const selectCatalogsVehicleError = createSelector(selectCatalogsVehicleState, (state) => state.error);
